// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__125ku","footer":"ModalCreateQualiphyProcedure_footer__Lr1d-","additionData":"ModalCreateQualiphyProcedure_additionData__2kP0F"};